import React, { Fragment } from 'react';

const ProgressBar = props => {
    const {
        processingPercentage
    } = props;

    return (
        <Fragment>
            <div className="progress_bar--container">
                <div className="progress_bar--bg">
                    <div style={{ width: processingPercentage+'%' }} className="progress_bar--per"></div>
                </div>
            </div>
            <div className="progress_bar--per-text">{processingPercentage}%</div>
        </Fragment>
    );
};

export default ProgressBar;
